<template>
  <!-- MODAL EDIT -->
  <b-modal
    id="modalAnydesk"
    title="Anydesk"
    size="lg"
    ok-title="ตกลง"
    ok-only
  >
    <b-row>
      <!-- GATEWAY NAME -->

      <b-col cols="12">
        <b-table
          responsive
          :items="items"
          :fields="fields"
        >
          <template #cell(anydesk)="data">
            <a :href="`anydesk:${data.item.anydesk}`">
              <b-button
                size="sm"
                variant="outline-danger"
              ><b-img
                src="@/assets/images/logo/anydesk.png"
                style="height: 16px; width: 16px;"
              /> <span style="color:#fff;"> {{ data.item.anydesk }}</span></b-button>
            </a>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BRow, BCol, BTable, BImg, BButton,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BImg,
    BButton,
  },
  data() {
    return {
      fields: [
        {
          key: 'num',
          label: 'ลำดับ',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'detail',
          label: 'จุดติดตั้ง',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'anydesk',
          label: 'Anydesk',
          sortable: false,
          class: 'text-center',
        },
      ],
      items: [],
      anydesk: '',
    }
  },
  computed: {
    // sortOptions() {
    //   // Create an options list from our fields
    //   return this.fields
    //     .filter(f => f.sortable)
    //     .map(f => ({ text: f.label, value: f.key }))
    // },
  },
  mounted() {
    this.gruopAnydesk()
  },
  methods: {
    gruopAnydesk() {
      axios
        .post('/getAnydeskAnalytic-G', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.anydesk = `anydesk:${response.data[0].anydesk}`
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
</style>
